<div class="input--container">
  <input class="qty-input m-0" min="0"  digitOnly type="number"
         (change)="onQuantityChanged($event)"
         (blur)="onQuantityBlur()"
         [value]="delivery.quantity"
         [disabled]="!canPurchase || delivery.is_uneligible || isItemCut"
  />

  <ng-container *ngIf="!collapsed">
    <div class="delivery--shipping-method">
      <ng-container *ngIf="hasShippingMethodError; else shippingMethodTemplate">
        <p class="text-center font-5 color--alert">Shipping method<br/>is not available</p>
      </ng-container>

    </div>


    <div class="delivery--wbs pt-0" *ngIf="canShowInternalOrder">
        <app-internal-order-code
                [order]="order"
                [orderItem]="orderItem"
                [readonly]="!canPurchase || delivery.is_uneligible"
                [disabled]="!canPurchase"
                class="full-width"
                [delivery]="delivery"
                (changed)="deliveryChanged()"></app-internal-order-code>
    </div>
  </ng-container>

  <div class="d-flex align-items-center justify-content-center">
    <span>TOTAL:&nbsp;</span>
    <span class="font-weight-bold price"><app-currency-price [price]="deliverySubtotal" [currency]="orderItemCurrency" [isItemCut]="isItemCut" ></app-currency-price></span>
  </div>
</div>

<ng-template #shippingMethodTemplate>
  <ng-container *ngIf="isSingleShippingMethod && !delivery.is_uneligible">
    <div class='shipping-method--wrapper'>
      <span>{{findMethodLabel(product, delivery)}}</span>
    </div>
  </ng-container>
  <ng-container *ngIf="!isSingleShippingMethod && !delivery.is_uneligible">
    <ng-select
      class="ng-select--custom product-list--view"
      style="max-width: 150px"
      [items]="shippingMethods"
      bindValue="method"
      [searchable]="false"
      (change)="updateShippingMethod($event)"
      [clearable]="false"
      [(ngModel)]="delivery.method"
      [disabled]="!canPurchase"
      dropdownPosition="bottom">
      <ng-template ng-label-tmp let-item="item">
        <span class="font-5 grey">{{ item.method_label }}</span>
      </ng-template>
      <ng-template ng-option-tmp let-item="item">
        <span class="font-5">{{ item.method_label }}</span>
      </ng-template>
    </ng-select>
  </ng-container>
</ng-template>
